<template>
<svg xmlns="http://www.w3.org/2000/svg" :fill="useCurrentColor ? 'currentColor' : '#000'" viewBox="0 0 48 48" :class="[`${prefix}-icon`, `${prefix}-icon-Edit`]" width="1em" height="1em" v-bind="$attrs"><defs><clipPath id="svg_95b351c862__a"><rect width="48" height="48" rx="0"/></clipPath></defs><g clip-path="url(#svg_95b351c862__a)"><path d="M22.4687,7C23.3689,7.000447006,24.1102,7.707314,24.1535,8.6064C24.1967,9.50549,23.5267,10.28026,22.630699999999997,10.36712L22.4687,10.375L14.59375,10.375C12.35108,10.3748,10.50023,12.12927,10.38062,14.36875L10.375,14.59375L10.375,34.2812C10.3748,36.5239,12.12928,38.3748,14.36875,38.4944L14.59375,38.5L34.2812,38.5C36.5239,38.5002,38.3748,36.7457,38.4944,34.5062L38.5,34.2812L38.5,26.4062C38.5004,25.5061,39.2073,24.7648,40.1064,24.7215C41.0055,24.6783,41.7803,25.3483,41.8671,26.2442L41.875,26.4062L41.875,34.2812C41.8751,38.3715,38.6356,41.7269,34.5479,41.8705L34.2812,41.875L14.59375,41.875C10.503540000000001,41.8751,7.148116,38.6356,7.00450199,34.5479L7,34.2812L7,14.59375C6.999902153,10.503540000000001,10.23943,7.148115,14.32712,7.00450199L14.59375,7L22.4687,7ZM39.9591,9.1105C40.5714,9.722339999999999,40.6215,10.69822,40.075,11.3695L39.9591,11.49775L26.4591,24.9977C25.8245,25.6359,24.8006,25.6637,24.1323,25.0609C23.464,24.458,23.3864,23.4368,23.956,22.7399L24.0719,22.6116L37.573,9.11162C38.232,8.45286,39.3002,8.45286,39.9591,9.11162L39.9591,9.1105Z"/></g></svg>
</template>
<script>

export default {
  name: 'IconEdit',
  props: {
    prefix: {
        type: String,
        default: 'cmstopgpt',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
